function getSessionStorageItem(key) {
    try {
        if (!globalThis.sessionStorage.hasOwnProperty(key)) {
            return null;
        }
        return globalThis.sessionStorage.getItem(key);
    } catch (err) {
        return null;
    }
}

export { getSessionStorageItem };
//# sourceMappingURL=get-session-storage-item.js.map
